// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__srPSq","header":"About_header__TjN3x","goBack":"About_goBack__4shnI","container":"About_container__2Dmaf","contentWrapper":"About_contentWrapper__ydF5R"};